'use strict';

require('whatwg-fetch');
/* eslint no-undef: 0, no-restricted-globals: 0 */


module.exports = self.fetch.bind(self);